// messages.js
export default {
    // The key format should be: 'locale.filename'.
    'de.general': require('../../resources/lang/de/general.php'),
    'de.events': require('../../resources/lang/de/events.php'),
    'de.invoices': require('../../resources/lang/de/invoices.php'),
    'de.locations': require('../../resources/lang/de/locations.php'),
    'de.labels': require('../../resources/lang/de/labels.php'),
    'de.dialogs': require('../../resources/lang/de/dialogs.php'),
    'de.messages': require('../../resources/lang/de/messages.php'),
    'de.errors': require('../../resources/lang/de/errors.php'),
    'en.general': require('../../resources/lang/en/general.php'),
    'en.events': require('../../resources/lang/en/events.php'),
    'en.invoices': require('../../resources/lang/en/invoices.php'),
    'en.locations': require('../../resources/lang/en/locations.php'),
    'en.labels': require('../../resources/lang/en/labels.php'),
    'en.dialogs': require('../../resources/lang/en/dialogs.php'),
    'en.messages': require('../../resources/lang/en/messages.php'),
    'en.errors': require('../../resources/lang/en/errors.php'),
}
